import { connect } from "react-redux";
import { startNewGame } from "actions";
import MenuComponent from "~/components/MenuComponent";

const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => ({
  startNewGame: () => {
    dispatch(startNewGame());
  }
});

const MenuContainer = connect(mapStateToProps, mapDispatchToProps)(
  MenuComponent
);

export default MenuContainer;



// WEBPACK FOOTER //
// ./src/routes/collections/containers/MenuContainer.js